<template>
  <div class="def-container">
    <page-head />
    <div class="page-wrapper">
      <nuxt />
    </div>
    <Footer v-if="$route.name.includes('index')" />
  </div>
</template>
<script>
import PageHead from '@components/PageHead';
import Footer from '@components/Footer';

export default {
  components: {
    PageHead,
    Footer
  },
  mounted() {
    this.$store.dispatch('fetchUserInfo');
  },
  head() {
    const i18nSeo = this.$nuxtI18nSeo();
    return {
      link: [...i18nSeo.link],
      meta: [...i18nSeo.meta],
      htmlAttrs: {
        class: ['default-layout-html-style'],
        ...i18nSeo.htmlAttrs
      },
      bodyAttrs: {
        class: ['default-layout-body-style']
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-width: 1080px;

  .page-wrapper {
    padding-top: 60px;
    padding-bottom: 80px;
    margin: 0 auto;
  }
}
</style>
<style lang="scss">
@import '@assets/scss/common.scss';
html {
  font-size: 14px;
  word-spacing: 1px;
  overflow-x: hidden;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}

a {
  color: #333;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

p {
  margin: 0;
}

ul,
ol {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

img {
  border: 0;
}

img[src=''] {
  width: auto;
  height: auto;
}

form {
  margin: 0;
}

input,
select {
  color: #333;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  -webkit-appearance: none;
}

textarea {
  color: #333;
  padding: 0;
  border: none;
  outline: none;
  -webkit-appearance: none;
  resize: none;
}

table {
  border-collapse: collapse;
  text-align: center;
}

td,
th {
  padding: 0;
}

.clearfix::after {
  content: '';
  display: block;
  clear: both;
  height: 0;
}

.clearfix {
  zoom: 1;
}

.def-container {
  min-width: 1080px;

  .page-wrapper {
    padding-top: 60px;
    margin: 0 auto;
  }
}
</style>
